import { render, staticRenderFns } from "./SelfDetails.vue?vue&type=template&id=70e91e92&scoped=true&"
import script from "./SelfDetails.vue?vue&type=script&lang=js&"
export * from "./SelfDetails.vue?vue&type=script&lang=js&"
import style0 from "./SelfDetails.vue?vue&type=style&index=0&id=70e91e92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e91e92",
  null
  
)

export default component.exports